import { Link, useLoaderData } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PipelineMappingsSection } from "./pipeline-mappings-section";
import { PipelineSyncSection } from "./pipeline-sync-section";

export function PipelineSyncPage() {
  const { pipelineSyncHistory, mappings, mappableColumns, hubspotFields } = useLoaderData({
    from: "/_authenticated/data-sync/pipelines",
  }) as {
    pipelineSyncHistory: any[];
    mappings: any[];
    mappableColumns: { pipeline: any[]; stage: any[] };
    hubspotFields: { pipeline: any[]; stage: any[] };
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Pipeline Sync"
        description="Mirror HubSpot deal pipelines and stages to local database"
        actions={
          <Button variant="outline" size="sm" asChild>
            <Link to="/data-sync">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Data Sync
            </Link>
          </Button>
        }
      />

      <Tabs defaultValue="sync">
        <TabsList>
          <TabsTrigger value="sync">Sync</TabsTrigger>
          <TabsTrigger value="mappings">Mappings</TabsTrigger>
        </TabsList>

        <TabsContent value="sync">
          <PipelineSyncSection initialHistory={pipelineSyncHistory} />
        </TabsContent>

        <TabsContent value="mappings">
          <PipelineMappingsSection
            initialMappings={mappings}
            mappableColumns={mappableColumns}
            hubspotFields={hubspotFields}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
